import { FormControl, FormControlLabel, Radio, RadioGroup, Typography, Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';

const RadioQuestion = (props) => {
    const { question, questionnaireIndex, questionIndex, editMode, name = null } = props;
    const { formState, setValue } = useFormContext();
    const { errors } = formState;

    useEffect(() => {
        if (name) {
            setValue(`${name}[${questionnaireIndex}].answers[${questionIndex}].answer`, [question?.Default] ?? null);
            setValue(`${name}[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        } else {
            setValue(`questionnaire[${questionnaireIndex}].answers[${questionIndex}].answer`, [question?.Default] ?? null);
            setValue(`questionnaire[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        }
    }, [questionIndex, questionnaireIndex]);

    const handleRadioChange = (event) => {
        if (name) {
            setValue(`${name}[${questionnaireIndex}].answers[${questionIndex}].answer`, [event.target.value]);
            setValue(`${name}[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        } else {
            setValue(`questionnaire[${questionnaireIndex}].answers[${questionIndex}].answer`, [event.target.value]);
            setValue(`questionnaire[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        }
    };

    return (
        <Grid item container xs={12}>
            <Grid item xs={12}>
                <Typography variant="h4">{question?.Title}</Typography>
            </Grid>
            {question.Options && (
                <Grid item xs={12}>
                    <FormControl
                        sx={{
                            borderColor: 'red'
                        }}
                        error={
                            name
                                ? !!errors[`${name}[${questionnaireIndex}].answers[${questionIndex}].answer`]
                                : !!errors[`questionnaire[${questionnaireIndex}].answers[${questionIndex}].answer`]
                        }
                        required={question?.rules?.required}
                        size="small"
                        fullWidth
                        disabled={!editMode}
                    >
                        <RadioGroup defaultValue={question?.Default ?? null} onChange={handleRadioChange}>
                            {question?.Options &&
                                question?.Options.sort((a, b) => a?.Position - b?.Position).map((option) => {
                                    return (
                                        <FormControlLabel
                                            key={option?.Value}
                                            value={option?.Value}
                                            control={<Radio />}
                                            label={option?.Label}
                                        />
                                    );
                                })}
                        </RadioGroup>
                    </FormControl>
                </Grid>
            )}
        </Grid>
    );
};

export default RadioQuestion;
